import { render } from "./GatewayInstallingForm.vue?vue&type=template&id=08369d27"
import script from "./GatewayInstallingForm.vue?vue&type=script&lang=js"
export * from "./GatewayInstallingForm.vue?vue&type=script&lang=js"
script.render = render

export default script